/** 加载中的转圈（ax-spinner）：放在触发加载的按钮左侧，加载期间显示、结束即移除；label 给读屏读出正在做什么。 */
export function Spinner({ label }: { label: string }) {
  return <span className="ax-spinner" role="status" aria-label={label} />;
}
